import { createFileRoute } from '@tanstack/react-router';

import { LoadingScreen } from '@/components/loading-screen';
import { SnapshotPanel } from '@/features/GroundTruthHub/SnapshotPanel';
import { GroundTruthNoAccess } from '@/features/GroundTruthHub/GroundTruthNoAccess';
import { useGroundTruthGuard } from '@/features/GroundTruthHub/useGroundTruthGuard';
import { groundTruthRouteBoundaries } from '@/features/GroundTruthHub/GroundTruthNotFound';

function GroundTruthSnapshotsPage() {
    const { isLoading, canAccess } = useGroundTruthGuard();

    if (isLoading) return <LoadingScreen />;
    if (!canAccess) return <GroundTruthNoAccess />;

    return <SnapshotPanel />;
}

export const Route = createFileRoute('/ground-truth/snapshots')({
    ...groundTruthRouteBoundaries,
    component: GroundTruthSnapshotsPage,
});
